import React, { useState } from 'react'

import LoanOfferSummaryPanelEditable from '../../molecules/LoanOfferSummaryPanelEditable/LoanOfferSummaryPanelEditable'
import LoanOfferSummaryPanelShort from '../../molecules/LoanOfferSummaryPanelShort/LoanOfferSummaryPanelShort'
import { LoanOfferSummaryPanelProps } from './LoanOfferSummaryPanelProps'
import { useLoanOfferSummaryPanelLogic } from './hooks/useLoanOfferSummaryPanelLogic'

/**
 * ORGANISM - Panel z podsumowaniem oferty pożyczki w trzech wariantach: skróconym, rozszerzonym (edytowalnym) i tylko do odczytu
 *    1. Skrócony - pokazuje podstawowe informacje o ofercie, posiada przycisk do rozwinięcia panelu
 *    2. Edytowalny - pokazuje szczegółowe informacje o ofercie, pozwala na edycję parametrów pożyczki za pomocą suwaków
 *    3. Tylko do odczytu - pokazuje szczegółowe informacje o ofercie, bez możliwości edycji parametrów pożyczki
 * 
 * !!! LOGIKA BIZNESOWA: Panel tylko do odczytu pokazuje dane z WYBRANEJ PRZEZ UŻYTKOWNIKA OFERTY, pozostałe dwa warianty pokazują dane z oferty PREDEFINIOWANEJ !!!
 * @param {Boolean} defaultOpen Czy panel ma być domyślnie otwarty po zamontowaniu komponentu
 * @param {ENUM} loanVariant Wariant przeliczenia z którego chcemy korzystać. Predefined to predefiniowana oferta, selectedOffer to oferta już wybrana i zatwierdzona przez użytkownika
 * @param {Boolean} readOnly Czy panel jest w trybie tylko do odczytu (brak przycisku do rozwijania)
 * @returns 
 */
const LoanOfferSummaryPanel = (props: LoanOfferSummaryPanelProps) => {
   const { readOnly = false, loanVariant = 'predefined', defaultOpen = false } = props
   const { 
      loanShortSummaryData, loanCalculatorStateParams, isLoanCalculatorOpen, 
      setLoanCalculatorOpen, onLoanValueSliderUpdate, isLoading, onValueChanged, handleOnPredefinedPeriodButtonClick } = useLoanOfferSummaryPanelLogic({ loanVariant, defaultOpen })

   
   if(isLoanCalculatorOpen) {
      return (
         <LoanOfferSummaryPanelEditable 
            loanCalculatorStateParams={loanCalculatorStateParams} 
            handleOnClose={() => setLoanCalculatorOpen(false)} 
            onLoanValueSliderUpdate={onLoanValueSliderUpdate}
            isLoading={isLoading}
            onValueChanged={onValueChanged}
            handleOnPredefinedPeriodButtonClick={handleOnPredefinedPeriodButtonClick}
         />
      )
   }
   else {
      return (
         <LoanOfferSummaryPanelShort readOnly={readOnly} handleOnOpen={() => setLoanCalculatorOpen(true)} { ...loanShortSummaryData } />
      )
   }
}

export default LoanOfferSummaryPanel